<section class="about px-8">
  <h2 class="text-2xl mt-8">
    Kontakt
  </h2>
  <div class="grid md:grid-cols-2 mt-8 p-8 md:p-12 bg-cover bg-center about__bg-image -mx-8">
    <div>
      <h3 class="mt-8 text-xl">
        EuroContact
      </h3>
      <p class="mt-4">
        <a href="mailto:eurocontact.kosmalski@gmail.com" class="block text-blue-700	">eurocontact.kosmalski@gmail.com</a>
        <a href="mailto:eurocontact.kosmalska@gmail.com" class="block text-blue-700	">eurocontact.kosmalska@gmail.com</a>
      </p>
      <p class="mt-4">
        Nr komórkowy: <a href="tel:+48605535999" class="text-blue-700">+48 605 535 999</a><br />
        Nr stacjonarny: <a href="tel:228831288" class="text-blue-700">22 88 312 88</a>
      </p>
      <p class="mt-4">
        Kurhan 18a lok. 11 <br />
        02-203 Warszawa
      </p>
      <p class="mt-4">
        NIP: 729 154 30 09
      </p>
    </div>
    <div>
    <p class="mt-8">
      Aby uzyskać więcej informacji na temat naszych produktów lub złożyć zamówienie, pomocne będzie przygotowanie wymiarów lady chłodniczej oraz informacji na temat asortymentu, jaki przewidujecie Państwo umieścić w ladzie.
    </p>
      <p class="mt-4 mb-8">
      Zapraszamy do kontaktu!<br>
      Jesteśmy dostępni codziennie w godzinach 08.00-18.00.
    </p>
  </div>
  </div>

</section>

<style>
  .about__bg-image {
    background-image: url('/assets/map.png');
  }
</style>